import {createAsyncThunk, createSlice, PayloadAction} from "@reduxjs/toolkit";
import {
    Broadcast, BROADCAST_SERVER_URL,
    BroadcastResponse,
    SERVER_URL,
    SESSION_URL,
    SessionData,
    Translation
} from "../contexts/Configuration";
import {RosettaClient} from '../api/RosettaClient';

type InitialState = {
    availableSessions: string[],
    translationMap: { [key: string]: { [key: string]: string[] } }

}

const initialState: InitialState = {
    availableSessions: [],
    // translationMap: new Map<string, Translation[]>()
    translationMap: {}
}

export const queryTranslation = createAsyncThunk<
    Broadcast,
    { userCode: string, shareCode: string, startPollingTimestamp: number },
    { rejectValue: string }
>('consumer/queryTranslation',
    async (params, {rejectWithValue}) => {

        return await fetch(BROADCAST_SERVER_URL + `broadcast/${params.userCode}/translations?shareCode=${params.shareCode}&transcriptionsFrom=${params.startPollingTimestamp}` , {
            method: 'GET',
            headers: {
                'content-type': 'application/json'
            }
        })
            .then(response => RosettaClient.marshalBroadcastResponse(response as BroadcastResponse))
            .then(response => {
                console.log('Broadcast response -> ', response);
                return response;
            });
    }
);

const consumerSlice = createSlice({
    name: 'consumer',
    initialState,
    reducers: {
        startPollingForTranslation(state, action: PayloadAction<string>) {
            // state.sessionId = action.payload;
        },
        updateTranslations(state, action: PayloadAction<SessionData>) {
            // console.log('received: ', action.payload.translations)
            // state.translationMap = new Map(Object.entries(action.payload.translations));
        }
    },
    extraReducers: builder => {
        builder.addCase(queryTranslation.pending, (state) => {
            // state.translationMap = new Map(Object.entries(action.payload.translations));
        })
        builder.addCase(queryTranslation.fulfilled, (state, action) => {
            if (!action.payload.error) {
                const sessionIds = Object.keys(action.payload.translations);
                console.log('queryTranslation.fulfilled: ', sessionIds, action.payload.translations);

                state.availableSessions = sessionIds;
                state.translationMap = action.payload.translations;
            }
        })
        builder.addCase(queryTranslation.rejected, (state, action) => {
            console.log('queryTranslation.rejected: ', action.payload)
            // state.translationMap = new Map(Object.entries(action.payload.translations));
        })
    }
});


export default consumerSlice.reducer;
export const {updateTranslations} = consumerSlice.actions;

